/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: aukbrhkegRkQ6KizvhdUPT

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/projectModule

import "../PP__plasmickit_design_system.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import "../PP__plasmickit_left_pane.css"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/projectcss
import "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss
import "../plasmic_kit_style_controls/plasmic_plasmic_kit_styles_pane.css"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/projectcss

const data = {
  base: `${"plasmic_tokens_aukbrhkegRkQ6KizvhdUPT"} ${"plasmic_tokens_tXkSR39sgCDWSitZxC5xFV"} ${"plasmic_tokens_95xp9cYcv7HrNWpFWWhbcv"} ${"plasmic_tokens_gYEVvAzCcLMHDVPvuYxkFh"}`,
  varianted: [],
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
